import { render } from "./gsrin030301.vue?vue&type=template&id=63b794d8&scoped=true"
import script from "./gsrin030301.vue?vue&type=script&lang=js"
export * from "./gsrin030301.vue?vue&type=script&lang=js"

import "./gsrin030301.vue?vue&type=style&index=0&id=63b794d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b794d8"]])

export default __exports__